export default "__VITE_ASSET__f6af48b2__"